import React from 'react';
import styled from 'styled-components';
import { UiGrid, UiGridProps } from '@open-stack/ui';

const Wrapper = styled(UiGrid)`
    grid-gap: 3px !important;
`;

export function XGridChain({ ...rest }: UiGridProps) {
    return <Wrapper {...rest} />;
}
